document.addEventListener("DOMContentLoaded", function () {
  // Enfocar automáticamente el campo de búsqueda al presionar el botón
  const searchButton = document.querySelector(".pt-dropdown-toggle");
  const searchInput = document.querySelector(".pt-search-input");

  if (searchButton && searchInput) {
    searchButton.addEventListener("click", function () {
      setTimeout(() => {
        searchInput.focus();
      }, 100);
    });
  }

  // Ocultar botón de WhatsApp en página de venta al por mayor
  if (window.location.pathname.includes("/pages/venta-al-por-mayor")) {
    const interval = setInterval(() => {
      const whatsappButton = document.querySelector("gty-whatsapp-chat-button");
      if (whatsappButton) {
        whatsappButton.style.display = "none";
        clearInterval(interval);
      }
    }, 300);
    setTimeout(() => clearInterval(interval), 5000);
  }

  // Esperar modal y activar redirección
  const modalInterval = setInterval(() => {
    const formDiv = document.querySelector(".modal-content .form-default");

    if (formDiv) {
      formDiv.style.cursor = "pointer";

      if (!formDiv.dataset.bound) {
        formDiv.addEventListener("click", function () {
          window.location.href = "https://dyaboo.com/collections/nuevo";
        });

        formDiv.dataset.bound = "true";
      }

      clearInterval(modalInterval);
    }
  }, 300);
  setTimeout(() => clearInterval(modalInterval), 5000);

  // Ajuste borde gris al color "Blanco"
  const applyWhiteBorder = () => {
    const whiteOptions = document.querySelectorAll(
      'a.options-color[data-tooltip="Blanco"], a.options-color[data-tooltip="blanco"]',
    );
    if (!whiteOptions || whiteOptions.length === 0) return;

    whiteOptions.forEach((option) => {
      if (!option.classList.contains("white-border-applied")) {
        option.style.border = "1px solid #ccc";
        option.style.boxSizing = "border-box";
        option.classList.add("white-border-applied");
      }
    });
  };

  applyWhiteBorder();
  const retry = setInterval(applyWhiteBorder, 300);
  setTimeout(() => clearInterval(retry), 5000);

  // Se definen desde theme.liquid
  // const ENABLED_FREE_SHIPPING_NOTICE = ...;
  // const FREE_SHIPPING_THRESHOLD = ...;

  if (ENABLED_FREE_SHIPPING_NOTICE) {
    function formatCurrency(amount) {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
      }).format(amount);
    }

    function updateFreeShippingNotice() {
      const totalElement = document.querySelector(".pt-cart-total-price");
      const noticeContainer = document.querySelector(".pt-envio-gratis-msg");

      if (!totalElement || !noticeContainer) {
        console.warn("[Envío DYABOO] No se encontró total o contenedor.");
        return;
      }

      const rawText = totalElement.textContent || "";
      const numericValue = parseInt(rawText.replace(/\D/g, ""), 10);
      if (isNaN(numericValue)) return;

      const percent = Math.min(
        (numericValue / FREE_SHIPPING_THRESHOLD) * 100,
        100,
      );
      const missing = FREE_SHIPPING_THRESHOLD - numericValue;

      let mensaje = "";
      if (numericValue >= FREE_SHIPPING_THRESHOLD) {
        mensaje = "🎁 ¡Felicitaciones! Tu envío será gratis 🎉";
      } else {
        mensaje = `Falta poco, adiciona ${formatCurrency(
          missing,
        )} más para conseguir <strong>¡envío GRATIS!</strong>`;
      }

      noticeContainer.innerHTML = `
        <div class="pt-envio-gratis-text">${mensaje}</div>
        <div class="pt-envio-bar">
          <div class="pt-envio-bar-fill" style="width: ${percent}%;">
            <span class="pt-envio-icon">🚚</span>
          </div>
        </div>
      `;

      // Ajuste posición del camión después de pintar
      const icon = noticeContainer.querySelector(".pt-envio-icon");
      if (icon) {
        icon.style.left = `calc(${percent}% - 10px)`;
      }
    }

    const cartList = document.querySelector(".pt-cart-list");
    if (cartList) {
      const observer = new MutationObserver(() => updateFreeShippingNotice());
      observer.observe(cartList, { childList: true, subtree: true });
      updateFreeShippingNotice();
    }
  }

  // === Mensaje dinámico para descuentos por volumen (Dr Volume Discounts) ===
  // Ya viene definido desde el <script> en el head

  if (ENABLED_VOLUME_DISCOUNT_NOTICE) {
    function updateVolumeDiscountNotice() {
      const noticeContainer = document.querySelector(
        ".pt-descuento-volumen-msg",
      );
      const itemElements = document.querySelectorAll(".pt-cart-list .pt-item");

      if (!noticeContainer) {
        console.warn("[Volumen DYABOO] ❌ Contenedor no encontrado.");
        return;
      }

      let totalUnidades = 0;
      let validosParaDescuento = true;

      itemElements.forEach((el) => {
        const qtyText = el.querySelector(".pt-quantity");
        if (!qtyText) return;

        const match = qtyText.textContent.match(/\d+/);
        const cantidad = match ? parseInt(match[0], 10) : 1;
        totalUnidades += cantidad;

        const esValido =
          el.getAttribute("data-coleccion") === VOLUME_DISCOUNT_COLLECTION;
        if (!esValido) validosParaDescuento = false;
      });

      console.log(
        `[Volumen DYABOO] Total unidades: ${totalUnidades} | Sólo productos válidos: ${validosParaDescuento}`,
      );

      if (!validosParaDescuento) {
        noticeContainer.textContent = "";
        return;
      }

      if (totalUnidades < 2) {
        noticeContainer.textContent = VOLUME_MSG_1;
      } else if (totalUnidades === 2) {
        noticeContainer.textContent = VOLUME_MSG_2;
      } else {
        noticeContainer.textContent = VOLUME_MSG_3;
      }
    }

    const cartList = document.querySelector(".pt-cart-list");

    if (cartList) {
      const observer = new MutationObserver(() => {
        updateVolumeDiscountNotice();
      });

      observer.observe(cartList, {
        childList: true,
        subtree: true,
      });

      updateVolumeDiscountNotice();
    }
  }
});
